import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Form } from "antd";
import useJDStore from "../../store/jd.store";
import useGlobalQCEStore from "../../store/globalqce.store";
import "./evaluations.scss";
import EvalutionsSummary from "../evaluationsSummary";
import EvaluationsConfigSummary from "../evaluationsConfigSummary";
import EvaluationsFilterSidebarFrom from "../evaluationsFilterSidebarForm";

import useQCEStore from "../../store/qce.store";
import EvaluationQuestionsCardList from "../evaluationsQuestionsCardList";

export default function Evaluations({
  setView,
  exist,
  qhjid,
  ev_id,
  evalDesc,
  currentView,
  globalEvaluationPage,
}) {
  const params = useParams();
  const { selectedJD } = useJDStore();
  const { getJDAllEvals, allJDEvalsQuestions, setFiterFlagQuestions } =
    useQCEStore();
  const { getQuestionsForEvaluation } = useGlobalQCEStore();
  const [formKey, setFormKey] = useState(1);
  const [form] = Form.useForm();
  const [localQSet, setLocalQSet] = useState([]);
  const [localQDescDeletedList, setLocalQDeletedSet] = useState([]);
  const [localFilteredList, setLocalFilteredQSet] = useState([]);
  const [localFilterView, setLocalFiltertView] = useState("normal"); //normal,filtered

  useEffect(() => {
    if (globalEvaluationPage) {
      const getEvalQuestions = async () => {
        await getQuestionsForEvaluation(ev_id);
        const updatedEvalQuestions =
          useGlobalQCEStore.getState().selectedGlobalEvalQuestions;
        if (updatedEvalQuestions?.length > 0) {
          setLocalQSet(updatedEvalQuestions);
          setLocalFilteredQSet(updatedEvalQuestions);
        }
      };
      getEvalQuestions();
    } else {
      const getQsetQuestions = async () => {
        await getJDAllEvals(qhjid, null);
        const updatedEvalQuestions = useQCEStore.getState().allJDEvalsQuestions;
        var localItem = updatedEvalQuestions?.filter(
          (item) => item?.qhevid == ev_id,
        );
        if (localItem?.[0].qdescarray != null) {
          //
          setLocalQSet(localItem?.[0].qdescarray);
          setLocalFilteredQSet(localItem?.[0].qdescarray);
        }
        if (currentPage != 1) {
          setCurrentPage(1);
        }
      };
      getQsetQuestions();
    }
  }, [currentView]);

  const [currentPage, setCurrentPage] = useState(1);
  const handleDelete = (event, indexToRemove) => {
    console.log("todelete", indexToRemove);
    //add deleted question to delete list
    localQDescDeletedList.push(localQSet[indexToRemove]);

    //now update the current list
    var localQSetNew = localQSet.filter((_, index) => index !== indexToRemove);
    setLocalQSet([...localQSetNew]);
    updateFilterList([...localQSetNew]);
  };

  const handleCopy = (event, indexToCopy) => {
    console.log("tocopy", indexToCopy);
    var itemToCopy;
    itemToCopy = {};
    itemToCopy.action = "ADD";
    itemToCopy.ID = null;
    itemToCopy.source = localQSet[indexToCopy].source;
    itemToCopy.questiontype = localQSet[indexToCopy].questiontype;
    itemToCopy.question = localQSet[indexToCopy].question;
    itemToCopy.multiplechoicecode = localQSet[indexToCopy].multiplechoicecode;
    itemToCopy.optiona = localQSet[indexToCopy].optiona;
    itemToCopy.optionb = localQSet[indexToCopy].optionb;
    itemToCopy.optionc = localQSet[indexToCopy].optionc;
    itemToCopy.optiond = localQSet[indexToCopy].optiond;
    itemToCopy.answer = localQSet[indexToCopy].answer;
    itemToCopy.explanation = localQSet[indexToCopy].explanation;
    itemToCopy.output = localQSet[indexToCopy].output;
    itemToCopy.level = localQSet[indexToCopy].level;
    itemToCopy.category = localQSet[indexToCopy].category;
    itemToCopy.skill = localQSet[indexToCopy].skill;
    itemToCopy.weightage = localQSet[indexToCopy].weightage;
    itemToCopy.assessmenttype = localQSet[indexToCopy].assessmenttype;
    itemToCopy.updatedby = {};
    itemToCopy.updatedby.qhuid = localQSet[indexToCopy].updatedby.qhuid;
    itemToCopy.updatedby.name = localQSet[indexToCopy].updatedby.updatedbyname;
    itemToCopy.updatedby.updatedon = localQSet[indexToCopy].updatedby.updatedon;

    const newArr = [
      ...localQSet.slice(0, indexToCopy), // empty array
      itemToCopy, // new element
      ...localQSet.slice(indexToCopy), // all original elements
    ];
    newArr[indexToCopy].ID = null;
    newArr[indexToCopy].action = "ADD";
    setLocalQSet([...newArr]);
    updateFilterList([...newArr]);
  };
  const handleEdit = (event, indexToCopy) => {
    console.log("toedit", indexToCopy);
    const itemToCopy = localQSet[indexToCopy];
    const newItems = [...localQSet];
    newItems.splice(indexToCopy + 1, 0, itemToCopy); // Insert after original
    setLocalQSet(newItems);
    updateFilterList(newItems);
  };

  const updateFilterList = (fList) => {
    setLocalFilteredQSet(fList);
    setFiterFlagQuestions();
  };

  const itemsPerPage = 15;
  const handlePageChange = (page) => {
    if (page !== currentPage) {
      setCurrentPage(page);
      console.log("SHOWING the current page", page);
    }
    //rdbResumeSearchPerPage();
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  return (
    <div className="evaluations-form-wrapper">
      <div className="evaluations-Stats">
        <EvalutionsSummary qhjid={qhjid} ev_id={ev_id} evalDesc={evalDesc} />
      </div>

      <div className="evaluations-summary-search">
        <EvaluationsConfigSummary
          qhjid={qhjid}
          ev_id={ev_id}
          evalDesc={evalDesc}
          localQDesc={localQSet}
        />
      </div>
      <div className="resumeDBSearchResults-filters">
        <EvaluationsFilterSidebarFrom
          qhjid={qhjid}
          ev_id={ev_id}
          evalDesc={evalDesc}
          localQDesc={localQSet}
          localFilteredList={localFilteredList} //init
          localFilteredQHanlder={updateFilterList}
          localfilterViewHandler={setLocalFiltertView}
        />
      </div>
      <div className="resumeDBSearchResults-card-list">
        <EvaluationQuestionsCardList
          qhjid={qhjid}
          ev_id={ev_id}
          evalDesc={evalDesc}
          localQDesc={localQSet}
          setView={setView}
          localQHanlder={setLocalQSet}
          localFilteredList={localFilteredList} //init
          localFilteredQHanlder={updateFilterList}
          localQDeleteHandler={handleDelete}
          localQCopyHandler={handleCopy}
          localQEditHandler={handleEdit}
          localQDescDeletedList={localQDescDeletedList}
          localFilterView={localFilterView}
          globalEvaluationPage={globalEvaluationPage}
        />
      </div>
    </div>
  );
}
